var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_203_705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.87012 18.4706L7.47678 20.0772L16.554 11L7.47678 1.92285L5.87012 3.52952L13.3407 11L5.87012 18.4706Z",
    fill: "#810CA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7853,
    height: 21.7853,
    fill: "white",
    transform: "translate(0.214844 0.107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevron);
export default __webpack_public_path__ + "static/media/RightChevron.030c1647591fc84f21ef8530d3bd6bb7.svg";
export { ForwardRef as ReactComponent };